export default __webpack_public_path__ + "static/media/GothamBookItalic.3de1b843.ttf";